import { ColorConstants } from '@shared/constants';
import styled from 'styled-components';

export const Label = styled.label`
    transition: all 0.4s;
    &:after, &:before {
        display: block;
        position: absolute;
        top: 1px;
        left: 2px;
        bottom: 1px;
        content: "";
    };
    &:before {
        background-color: ${({ disabledBackground }) => disabledBackground};
        border-radius: 60px;
        right: 1px;
        transition: all 0.4s;
    }
    &:after {
        background-color: ${ColorConstants.white};
        box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.161);
        border-radius: 100%;
        height: 80%;
        margin-top: 1px;
        transition: all 0.4s;
        width: 18px;
    }
`;

export const Input = styled.input`
    position: absolute;
    margin-left: -9999px;
    visibility: hidden;
    + ${Label} {
        background-color: ${({ disabledBackground }) => disabledBackground};
        border-radius: 60px;
        cursor: pointer;
        display: block;
        height: 22px;
        margin: 0;
        outline: none;
        padding: 2px;
        position: relative;
        user-select: none;
        width: 38px;
    }
    &:checked + ${Label}:before {
        background-color: ${({ enabledBackground }) => enabledBackground};
    }
    &:checked + ${Label} {
        background-color: ${({ enabledBackground }) => enabledBackground};
    }
    &:checked + ${Label}:after {
        transform: translateX(15px);
    }
    &:disabled + ${Label}, &:disabled + ${Label}:before, &:disabled + ${Label}:after {
        background-color: ${ColorConstants.zircon}
    }
`;
